import { useState, useEffect } from 'react'
import { supabase } from '../../../lib/supabase'
import { useAuth } from '../../../contexts/auth-context'

export function usePortalUnreadCount() {
  const { user } = useAuth()
  const [unreadCount, setUnreadCount] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user?.id) { setLoading(false); return }
    async function fetch() {
      const { count, error } = await (supabase as any)
        .from('client_messages')
        .select('*', { count: 'exact', head: true })
        .eq('recipient_id', user!.id)
        .eq('is_read', false)
      if (!error && count !== null) setUnreadCount(count)
      setLoading(false)
    }
    fetch()
  }, [user?.id])

  return { unreadCount, loading }
}
